// 5x5 risk-matrix bands using the platform's semantic palette
// (Theme.jsx: anGreen/highlight/anOrange/anRed) so the register matches the
// rest of the app. Thresholds align with the CQC Centre's high-risk
// threshold (>= 8) and the governance KPI red-risk threshold (>= 15).
export const getRAGband = (rating) => {
  if (!rating || rating <= 0) return { color: '#94A3B8', label: 'Unscored' }
  if (rating >= 15) return { color: '#E32525', label: 'Extreme' }
  if (rating >= 8) return { color: '#F28B1F', label: 'High' }
  if (rating >= 4) return { color: '#CCA43B', label: 'Moderate' }
  return { color: '#00964C', label: 'Low' }
}

const getRAGcolor = (rating) => getRAGband(rating).color

export default getRAGcolor
